export enum AccessAction {
    access = "access",
    administrate = "administrate",
    delete = "delete",
    query = "query",
    write = "write",
}

/**
 * Features, that can be enabled or disabled for a user.
 */
export enum AccessFeature {
    activities = "activities",
    activities_menu = "activities_menu",
    api = "api",
    app = "app",
    bobst_shop_connector = "bobst_shop_connector",
    collections = "collections",
    dashboard = "dashboard",
    //TODO: QIT-6603 Remove once the generic shop replaces the per-provider connectors
    dev_generic_shop = "dev_generic_shop",
    documentation_menu = "documentation_menu",
    fdi_shop_connector = "fdi_shop_connector",
    file_manager = "file_manager",
    //TODO: QIT-6160 Remove temp feature flag
    fresenius_shop_gui = "fresenius_shop_gui",
    fuzzy_search = "fuzzy_search",
    combined_view = "combined_view", //TODO: muss noch im feature plan umgenannt werden
    image_search_gui = "image_search_gui",
    notes = "notes",
    playground = "playground",
    products = "products",
    public_notes = "public_notes",
    rag_auto_prompt = "rag_auto_prompt",
    rag_search_dropdown_gui = "rag_search_dropdown_gui",
    rag_feedback = "rag_feedback",
    rag_gui = "rag_gui",
    rag_product_taxonomy = "rag_product_taxonomy",
    rag_anonymous = "rag_anonymous",
    rag_rbac = "rag_rbac",
    schematic_viewer = "schematic",
    shop = "webshop",
    shop_light = "shop_light",
    spare_parts = "spare_parts",
    swarovski_shop_connector = "swarovski_shop_connector",
    topic_navigation = "topic_navigation",
    parts_classification_search_gui = "parts_classification_search_gui",
    parts_search_low_res = "parts_search_low_res",
    ai_speech_input = "ai_speech_input",
    connect26_gui = "connect26_gui",
    extendable_gui = "extendable_gui",
    pdf_viewer_save = "pdf_viewer_save",
    pdf_viewer_print = "pdf_viewer_print",
}

/**
 * User resources, that can be accessed by a user.
 */
export enum AccessResource {
    activities = "activities",
    admin_area = "admin-area",
    assets = "assets",
    collections = "collections",
    config_3d = "config.3d",
    config_product_and_asset = "config.product-and-asset",
    contents = "contents",
    data_display_configs = "data-display-configs",
    data_ingest_data = "data.ingest-data",
    datas = "datas",
    facet_collections = "facet-collections",
    files = "files",
    jobs = "jobs",
    mechanics = "mechanics",
    notes = "notes",
    notes_comments = "notes.comments",
    notifications = "notifications",
    pdf_publishing = "pdf-publishing",
    products = "products",
    rag = "rag",
    search_configs = "search-configs",
    shop = "shop",
    tenant = "tenant",
    theme = "themes",
    user_app_key = "user.app-key",
    userSettings = "user-settings",
    users = "users",
}
